export function parseFailuresIntoArray(
    failures:
        | Record<string, string | {error?: string; failedAt?: string; accountID?: string}>
        | undefined
) {
    if (!failures) {
        return failures;
    }
    const result = Object.keys(failures).reduce((map, key) => {
        const obj = failures[key];
        let error: string | undefined;
        let accountID: string | undefined;
        if (typeof obj === "string") {
            error = obj;
        }
        if (typeof obj === "object" && obj.error) {
            error = obj.error;
            accountID = obj.accountID;
        }
        if (error) {
            map.set(key, {error, accountID});
        }
        return map;
    }, new Map<string, {error: string; accountID?: string}>());
    return [...result];
}
